/**
 * External Dependencies
 */
import 'lazysizes';

import 'jquery';
import { Fancybox } from '@fancyapps/ui';
import footerPopover from './partials/footer-popover';
import InfiniteScroll from 'infinite-scroll';
import Plyr from 'plyr';
import Swiper, { Navigation, Pagination, Autoplay, Mousewheel } from 'swiper';
import AOS from 'aos';
import StickySidebar from 'sticky-sidebar';


$(() => {

	 // global
  let listingID = '#listing';


	function modalTrigger() {
		if($('.is-modal').length) {
			window.setTimeout(function(){
				console.log('timed');
        $('.is-modal').addClass('active');
				$('body').addClass('modal-open');
   		}, 2000);

			$('a[href*="#close-modal"]').each(function() {
				$(this).on( "click", function() {
					$('.is-modal').removeClass('active');
					$('body').removeClass('modal-open');
				});
			});
		}
	}



  function handleBurger() {
    let burger = document.querySelector('.burger'),
      navigationMobile = document.querySelector('.navigation__mobile');

    burger.addEventListener('click', function () {
      burger.classList.toggle('active');
      navigationMobile.classList.toggle('active');
    });
  }

  function handleSubMenus() {
    let navigation = document.querySelector('.navigation');

    if (navigation !== null) {
			if($('.menu-column-info').length) {
				$('.navbar-dropdown-wrapper > span').each(function(i, obj) {
					let color = $(this).attr("data-color");
					let bgColor = $(this).attr("data-bg");
					$(this).parent().css({
						'background-color' : bgColor,
						'color' : color
				 });
				 if($(this).attr("data-notwhite") == 'not-white') {
					$(this).parent().addClass('has-bg-color');
				 }
				});
			}


				$( ".navigation__menu .menu-item-has-children .main-menu-link a" ).on( "click", function(e) {
						e.preventDefault();
						$(this).closest('.menu-item-has-children').addClass('active');
						$(this).parents('.menu-item-has-children').find('.go-back-text').html($(this).text());
				});
				$( ".navigation__menu .go-back" ).on( "click", function(e) {
					e.preventDefault();
					$(this).parent().closest('.menu-item-has-children').removeClass('active');
				});
			$( window ).resize(function() {
				if(window.innerWidth < 1024) {
					$( ".navigation__menu .menu-item-has-children .main-menu-link a" ).on( "click", function(e) {
							e.preventDefault();
							$(this).closest('.menu-item-has-children').addClass('active');
							$(this).parents('.menu-item-has-children').find('.go-back-text').html($(this).text());
					});
					$( ".navigation__menu .go-back" ).on( "click", function(e) {
						e.preventDefault();
						$(this).parent().closest('.menu-item-has-children').removeClass('active');
					});
				}
			});

    }
  }

  function handleFooterMenus() {
    let footer = document.querySelector('.footer');

    if (footer !== null) {
			if($('.menu-column-info').length) {
				$('.menu-wrapper > span').each(function(i, obj) {
					let color = $(this).attr("data-color");
					let bgColor = $(this).attr("data-bg");
					$(this).parent().css({
						'background-color' : bgColor,
						'color' : color
				 });
				 if($(this).attr("data-notwhite") == 'not-white') {
					$(this).parent().addClass('has-bg-color');
				 }
				});
			}
		}
	}

  function handleFancyBox() {
    let button = document.querySelector('.domino__play');

    if (button !== null) {
      button.addEventListener('click', function (e) {
        e.preventDefault();

        Fancybox.show(
          [
            {
              src: button.href,
              type: 'video',
            },
          ],
          {
            Html: {
              video: {
                autoplay: true,
              },
            },
          }
        );
      });
    }

    Fancybox.bind('[data-fancybox-plyr]', {
      on: {
        reveal: (fancybox, slide) => {
          if (typeof Plyr === undefined) {
            return;
          }

          let $el;

          if (slide.type === 'html5video') {
            $el = slide.$content.querySelector('video');
          } else if (slide.type === 'video') {
            $el = document.createElement('div');
            $el.classList.add('plyr__video-embed');

            $el.appendChild(slide.$iframe);

            slide.$content.appendChild($el);
          }

          // if ($el) {
            slide.player = new Plyr($el, { autoplay: true });
          // }
        },
        'Carousel.unselectSlide': (fancybox, carousel, slide) => {
          if (slide.player) {
            slide.player.pause();
          }
        },
        'Carousel.selectSlide': (fancybox, carousel, slide) => {
          if (slide.player) {
            slide.player.play();
          }
        },
      },
    });
  }

  function handleSliders() {
    // Swiper.use([Navigation, Pagination]);

    window.addEventListener('load', function () {
      let slider = new Swiper('.slider .swiper', {
        loop: true,
        modules: [Navigation, Pagination],
        pagination: {
          el: '.slider .swiper-pagination',
          clickable: true,
        },
      })

	  let quoteSlider = new Swiper('.slider .swiper', {
        loop: true,
        modules: [Navigation, Pagination, Autoplay],
		autoplay: {
			delay: 4000,
			disableOnInteraction: false,
		  },
        pagination: {
          el: '.slider .swiper-pagination',
          clickable: true,
        },
      })

      let gallery = new Swiper('.gallery .swiper', {
        slidesPerView: 'auto',
        modules: [Navigation, Pagination],
        spaceBetween: 20,
        pagination: {
          el: ".gallery .swiper-pagination",
          type: "fraction",
        },
        navigation: {
          prevEl: '.gallery .swiper-button-prev',
          nextEl: '.gallery .swiper-button-next',
        },
      })

      let tabs = new Swiper('.tabs .swiper', {
        slidesPerView: 1,
        modules: [Navigation, Pagination],
        spaceBetween: 20,
        pagination: {
          el: ".tabs .swiper-pagination",
          type: "bullets",
          clickable: true,
          renderBullet: function (index, className) {
            let slides = document.querySelector('.tabs .swiper-wrapper').children;

            // console.log(slides[0].dataset.label);

            return `<span class="swiper-pagination-bullet"><span class="swiper-pagination-number">${index < 10 ? "0" : ""}${index + 1}</span><span class="swiper-pagination-text">${slides[index].dataset.label}</span></span>`;
          },
        },
      })

	  let tabsVertical = new Swiper('.tabsVertical .swiper', {
        slidesPerView: 1,
        modules: [Navigation, Pagination],
        spaceBetween: 20,
		autoHeight: true,
    //    direction: "vertical",
		mousewheel: true,
        pagination: {
          el: ".tabsVertical .swiper-pagination",
          type: "bullets",
          clickable: true,
          renderBullet: function (index, className) {
            let slides = document.querySelector('.tabsVertical .swiper-wrapper').children;

            // console.log(slides[0].dataset.label);

            return `<span class="swiper-pagination-bullet"><span class="swiper-pagination-number">${index < 10 ? "0" : ""}${index + 1}</span><span class="swiper-pagination-text">${slides[index].dataset.label}</span></span>`;
          },
        },
      })

	  let tabsUpdated = new Swiper('.tabsUpdated .swiper', {
        slidesPerView: 1,
        modules: [Navigation, Pagination],
        spaceBetween: 20,
		mousewheel: true,
        pagination: {
          el: ".tabsUpdated .swiper-pagination",
          type: "bullets",
          clickable: true,
          renderBullet: function (index, className) {
            let slides = document.querySelector('.tabsUpdated .swiper-wrapper').children;

            // console.log(slides[0].dataset.label);

            return `<span class="swiper-pagination-bullet"><span class="swiper-pagination-number">${index < 10 ? "0" : ""}${index + 1}</span><span class="swiper-pagination-text">${slides[index].dataset.label}</span></span>`;
          },
        },
      })

	  let scrollContainer = new Swiper('.scroll-container .swiper', {
		direction: "vertical",
		slidesPerView: 1,
		modules: [Pagination, Mousewheel],
		spaceBetween: 30,
		mousewheel: true,
		pagination: {
			el: ".scrollContainer .swiper-pagination",
			clickable: true,
		  },
      })

      let singlePost = new Swiper('.single-post__slider .swiper', {
        slidesPerView: 1,
        spaceBetween: 20,
        breakpoints: {
          // when window width is >= 320px
          1024: {
            slidesPerView: 3,
            spaceBetween: 40
          },
        },
      });
    })

  }

  function handleLanguagesList() {
		$( ".languages__toggle" ).on( "click", function(e) {
			$('.languages__list').toggleClass('active');
    })
  }

  function handleInfiniteScroll() {
    var elem = document.getElementById('posts'),
      btn = document.querySelector('.btn--load');

    if (elem !== null && btn !== null) {
      var infScroll = new InfiniteScroll(elem, {
        // options
        loadOnScroll: false,
        path: '.btn--load a',
        append: '.card',
        history: false,
        button: '.btn--load a',
      });

      btn.addEventListener('click', function (e) {
        infScroll.option({
          loadOnScroll: true
        });

        this.parentNode.classList.add('hidden');
      })
    }
  }

  function handleSelect() {
    let selects = document.querySelectorAll('.select'),
      params = (new URL(document.location)).searchParams;

    for (let i = 0; i < selects.length; i++) {
      const select = selects[i],
        toggle = selects[i].querySelector('.select__toggle');

      select.addEventListener('click', function (e) {
        let target = e.target;

        if (target.classList.contains('select__toggle')) {
          target.nextElementSibling.classList.toggle('active');
        }

        if (target.classList.contains('select__item')) {
          let param = target.parentNode.previousElementSibling,
            url = '?';

          url += `${param.dataset.param}=${target.dataset.value}&`

          params.forEach((value, key) => {
            if (key == param.dataset.param) {
              return;
            } else {
              url += `${key}=${value}&`
            }
          })

          location.href = url + listingID;
        }
      })
      let selected;
      if (selected = params.get(toggle.dataset.param)) {
        if ($.isNumeric(selected)) {
          toggle.innerText = select.querySelector('[data-value="' + selected + '"]').innerText;
        } else{
          toggle.innerText = select.querySelector(`[data-value=${selected}]`).innerText;
        }
      }
    }
  }

  function handleResourceFilters() {
    let button = document.querySelector('.btn--filter'),
      cross = document.querySelector('.filters__cross'),
      filters = document.querySelector('.filters'),
      params = (new URL(document.location)).searchParams;

    if (filters !== null) {

      // toggle filters menu
      if (button !== null) {
        button.addEventListener('click', function () {
          filters.classList.toggle('active');
        })

        cross.addEventListener('click', function () {
          filters.classList.toggle('active');
        })
      }

      // handle filtering
      filters.addEventListener('click', function (e) {
        let target = e.target;

        // show filter buttons
        if (target.classList.contains('filters__tax')) {
          target.classList.toggle('active');
          target.nextElementSibling.classList.toggle('hidden');
        }

        // clears filters
        if (target.classList.contains('filters__clear')) {
          location.href = window.location.pathname + listingID;
        }

        // add active class to clicked filter buttons
        if (target.classList.contains('btn--thick')) {
          e.target.classList.toggle('active');
        }

        // apply filters
        if (target.classList.contains('btn--apply')) {
          let list = document.querySelector('.filters__list'),
            args = [],
            url = '?';

          // loop through each tax
          Array.from(list.children).forEach(el => {
            let listChildItem = el.querySelector('[data-param]'),
              taxObject = {
                param: '',
                values: []
              };

            taxObject.param = listChildItem.dataset.param;

            // loop through each tax's items and check for active buttons
            Array.from(listChildItem.children).forEach(childEl => {
              let childItem = childEl.querySelector('.btn');

              if (childItem.classList.contains('active')) {
                let taxChildArg = `${childItem.dataset.value}`;

                taxObject.values.push(taxChildArg);
              }
            })

            args.push(taxObject);
          });

          // formulate string, update URL and refresh the page
          args.forEach(el => {
            if (url.length > 0) {
              url += '&';
            }

            url += `${el.param}=`;

            el.values.forEach((childEl, i) => {
              url += `${childEl},`;
            })
          })

          params.forEach((value, key) => {
            if (key == 'resource_type' || key == 'use_case' || key == 'industry') {
              return;
            } else {
              url += `&${key}=${value}`
            }
          })

          // refresh page with update url
          location.href = url + listingID;
        }
      })
    }
  }

  function handleResourceTags() {
    let tags = document.querySelector('.filters__tags'),
      params = (new URL(document.location)).searchParams;

    if (tags !== null) {
      if (!params) {
        if (tags !== null) {
          tags.classList.add('hidden');
        }
        return;
      }

      params.forEach((value, key) => {
        if (!value || key == 'order' || key == 's') return;

        // remove potential comma
        value = value.split(',');

        // generate and append tags based on search params
        value.forEach(name => {
          if (name.length > 0) {
            let tag = document.createElement('div'),
              span = document.createElement('span');

            span.classList.add('me-4', 'inline-block');

            tag.classList.add('btn', 'btn--small', 'btn--tag', 'capitalize');
            tag.innerText = name.replaceAll('-', ' ');
            tag.appendChild(span);

            tags.appendChild(tag);
          }
        })
      })

      // refresh posts when dismissing tags
      tags.addEventListener('click', function (e) {
        let target = e.target,
          str = target.innerText.toLowerCase().replaceAll(' ', '-'),
          str_comma = str + ',';

        if (target.classList.contains('btn--tag')) {
          location.href = window.location.pathname + window.location.search
            .replace(str_comma, '')
            .replace(str, '') + listingID;
        }
      })
    }
  }

  function handleAlert() {
    let alert = document.querySelector('.alert');
		let body = document.querySelector('body');
    if (alert !== null && JSON.parse(localStorage.getItem('hideAlert')) !== true) {
      alert.classList.toggle('hidden');
			body.classList.toggle('has-alert');
			window.addEventListener("scroll", function() {
				if (alert !== null && JSON.parse(localStorage.getItem('hideAlert')) !== true) {
					if (window.scrollY >= 1) {
						body.classList.remove('has-alert');
					} else {
						body.classList.add('has-alert');
					}
				}
			});
      alert.addEventListener('click', function (e) {
        if (e.target.classList.contains('alert__cross')) {
          alert.classList.add('hidden');
					body.classList.remove('has-alert');
          localStorage.setItem('hideAlert', JSON.stringify(true));
        }
      })
    }
  }

  function handleAnimations() {
			AOS.init({
				duration: 500,
				once: true,
				offset: 50
			});

			window.addEventListener('load', () => {
				AOS.refresh();

			})

			document.querySelectorAll('img').forEach(function (img) {
				img.addEventListener('load', function () {
					AOS.refresh();
				});
			});
		}


  function handleMonthTranslation() {
    let dates = document.querySelectorAll('.date'),
      selectedMonths,
      languages = ['/nl/', '/de/', '/fr/', '/it/', '/es/'],
      months = {
        'en': ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        'nl': ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'],
        'fr': ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
        'de': ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
        'it': ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'],
        'es': ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
      };

    if (dates !== null) {
      // find language from URL
      languages.forEach(item => {
        if (window.location.href.includes(item)) {
          let lang = item.replace(/\//g, '');

          selectedMonths = months[lang];
        }
      })

      // loop through dates and replace with transalted version
      Array.from(dates).forEach(date => {
        months['en'].forEach((month, i) => {
          if (date.innerText.includes(month) && selectedMonths !== undefined) {
            date.innerText = date.innerText.replace(month, selectedMonths[i]);
          }
        })
      })
    }
  }

  // blocks
  function handleAccordionBlock() {
    let accordion = document.querySelector('.accordion');

    if (accordion !== null) {
      accordion.addEventListener('click', function (e) {

        if (e.target.classList.contains('accordion__tab')) {
          let tab = e.target;

          tab.nextElementSibling.classList.toggle('hidden');
          tab.querySelector('.accordion__chevron').classList.toggle('rotate-0');

        }
      })
    }
  }

	function scrollProgression() {
		if($('body').hasClass('single-post')) {
			$('body #app div > header').append('<div class="progression-bar"><span></span></div>');
			$(document).on("scroll", function(){
				var pixels = $(document).scrollTop();
				var pageHeight = $(document).height() - $(window).height();
				var progress = 100 * pixels / pageHeight;
				$("div.progression-bar span").css("width", progress + "%");
			})
		}
	}

	function copyText() {
		$('.copy-text').on("click", function(e){
			e.preventDefault();
			var value = $(this).data('clipboard-text');
			var $temp = $("<input>");
				$("body").append($temp);
				$temp.val(value).select();
				document.execCommand("copy");
				$temp.remove();
		});
	}

	function toggleBoxedAccordion() {
		if($('.boxed-accordion').length){
			$('.boxed-accordion .item .item-title').on("click", function(e){
				e.preventDefault();
				$(this).parent().toggleClass('active');
				$(this).parent().siblings().removeClass('active');
			});
		}
	}

	function toggleImageAccordion() {
		if($('.image-accordion').length){
			$('.image-accordion .item:first').addClass('active');
			$('.image-accordion .item .item-title').on("click", function(e){
				e.preventDefault();
				$(this).parent().toggleClass('active');
				$(this).parent().siblings().removeClass('active');
			});
		}
	}

	function addID() {
		if($('.single-post').length){
			$('h2').each(function() {
				$(this).attr('id', $(this).text().toLowerCase().replace(/ /g, '-'))
			});
			$('h3').each(function() {
				$(this).attr('id', $(this).text().toLowerCase().replace(/ /g, '-'))
			});
			$('h4').each(function() {
				$(this).attr('id', $(this).text().toLowerCase().replace(/ /g, '-'))
			});
		}
	}
	function sidebarSticky() {
		if($('#sidebar').length){
			(function (root, factory) {
				if (typeof define === "function" && define.amd) {
						define(factory);
				} else if (typeof exports === "object") {
						module.exports = factory();
				} else {
						root.ResizeSensor = factory();
				}
		}(typeof window !== 'undefined' ? window : this, function () {

				// Make sure it does not throw in a SSR (Server Side Rendering) situation
				if (typeof window === "undefined") {
						return null;
				}
				// https://github.com/Semantic-Org/Semantic-UI/issues/3855
				// https://github.com/marcj/css-element-queries/issues/257
				var globalWindow = typeof window != 'undefined' && window.Math == Math
						? window
						: typeof self != 'undefined' && self.Math == Math
								? self
								: Function('return this')();
				// Only used for the dirty checking, so the event callback count is limited to max 1 call per fps per sensor.
				// In combination with the event based resize sensor this saves cpu time, because the sensor is too fast and
				// would generate too many unnecessary events.
				var requestAnimationFrame = globalWindow.requestAnimationFrame ||
						globalWindow.mozRequestAnimationFrame ||
						globalWindow.webkitRequestAnimationFrame ||
						function (fn) {
								return globalWindow.setTimeout(fn, 20);
						};

				var cancelAnimationFrame = globalWindow.cancelAnimationFrame ||
						globalWindow.mozCancelAnimationFrame ||
						globalWindow.webkitCancelAnimationFrame ||
						function (timer) {
								globalWindow.clearTimeout(timer);
						};

				/**
				 * Iterate over each of the provided element(s).
				 *
				 * @param {HTMLElement|HTMLElement[]} elements
				 * @param {Function}                  callback
				 */
				function forEachElement(elements, callback){
						var elementsType = Object.prototype.toString.call(elements);
						var isCollectionTyped = ('[object Array]' === elementsType
								|| ('[object NodeList]' === elementsType)
								|| ('[object HTMLCollection]' === elementsType)
								|| ('[object Object]' === elementsType)
								|| ('undefined' !== typeof jQuery && elements instanceof jQuery) //jquery
								|| ('undefined' !== typeof Elements && elements instanceof Elements) //mootools
						);
						var i = 0, j = elements.length;
						if (isCollectionTyped) {
								for (; i < j; i++) {
										callback(elements[i]);
								}
						} else {
								callback(elements);
						}
				}

				/**
				* Get element size
				* @param {HTMLElement} element
				* @returns {Object} {width, height}
				*/
				function getElementSize(element) {
						if (!element.getBoundingClientRect) {
								return {
										width: element.offsetWidth,
										height: element.offsetHeight
								}
						}

						var rect = element.getBoundingClientRect();
						return {
								width: Math.round(rect.width),
								height: Math.round(rect.height)
						}
				}

				/**
				 * Apply CSS styles to element.
				 *
				 * @param {HTMLElement} element
				 * @param {Object} style
				 */
				function setStyle(element, style) {
						Object.keys(style).forEach(function(key) {
								element.style[key] = style[key];
						});
				}

				/**
				 * Class for dimension change detection.
				 *
				 * @param {Element|Element[]|Elements|jQuery} element
				 * @param {Function} callback
				 *
				 * @constructor
				 */
				var ResizeSensor = function(element, callback) {
						//Is used when checking in reset() only for invisible elements
						var lastAnimationFrameForInvisibleCheck = 0;

						/**
						 *
						 * @constructor
						 */
						function EventQueue() {
								var q = [];
								this.add = function(ev) {
										q.push(ev);
								};

								var i, j;
								this.call = function(sizeInfo) {
										for (i = 0, j = q.length; i < j; i++) {
												q[i].call(this, sizeInfo);
										}
								};

								this.remove = function(ev) {
										var newQueue = [];
										for(i = 0, j = q.length; i < j; i++) {
												if(q[i] !== ev) newQueue.push(q[i]);
										}
										q = newQueue;
								};

								this.length = function() {
										return q.length;
								}
						}

						/**
						 *
						 * @param {HTMLElement} element
						 * @param {Function}    resized
						 */
						function attachResizeEvent(element, resized) {
								if (!element) return;
								if (element.resizedAttached) {
										element.resizedAttached.add(resized);
										return;
								}

								element.resizedAttached = new EventQueue();
								element.resizedAttached.add(resized);

								element.resizeSensor = document.createElement('div');
								element.resizeSensor.dir = 'ltr';
								element.resizeSensor.className = 'resize-sensor';

								var style = {
										pointerEvents: 'none',
										position: 'absolute',
										left: '0px',
										top: '0px',
										right: '0px',
										bottom: '0px',
										overflow: 'hidden',
										zIndex: '-1',
										visibility: 'hidden',
										maxWidth: '100%'
								};
								var styleChild = {
										position: 'absolute',
										left: '0px',
										top: '0px',
										transition: '0s',
								};

								setStyle(element.resizeSensor, style);

								var expand = document.createElement('div');
								expand.className = 'resize-sensor-expand';
								setStyle(expand, style);

								var expandChild = document.createElement('div');
								setStyle(expandChild, styleChild);
								expand.appendChild(expandChild);

								var shrink = document.createElement('div');
								shrink.className = 'resize-sensor-shrink';
								setStyle(shrink, style);

								var shrinkChild = document.createElement('div');
								setStyle(shrinkChild, styleChild);
								setStyle(shrinkChild, { width: '200%', height: '200%' });
								shrink.appendChild(shrinkChild);

								element.resizeSensor.appendChild(expand);
								element.resizeSensor.appendChild(shrink);
								element.appendChild(element.resizeSensor);

								var computedStyle = window.getComputedStyle(element);
								var position = computedStyle ? computedStyle.getPropertyValue('position') : null;
								if ('absolute' !== position && 'relative' !== position && 'fixed' !== position && 'sticky' !== position) {
										element.style.position = 'relative';
								}

								var dirty = false;

								//last request animation frame id used in onscroll event
								var rafId = 0;
								var size = getElementSize(element);
								var lastWidth = 0;
								var lastHeight = 0;
								var initialHiddenCheck = true;
								lastAnimationFrameForInvisibleCheck = 0;

								var resetExpandShrink = function () {
										var width = element.offsetWidth;
										var height = element.offsetHeight;

										expandChild.style.width = (width + 10) + 'px';
										expandChild.style.height = (height + 10) + 'px';

										expand.scrollLeft = width + 10;
										expand.scrollTop = height + 10;

										shrink.scrollLeft = width + 10;
										shrink.scrollTop = height + 10;
								};

								var reset = function() {
										// Check if element is hidden
										if (initialHiddenCheck) {
												var invisible = element.offsetWidth === 0 && element.offsetHeight === 0;
												if (invisible) {
														// Check in next frame
														if (!lastAnimationFrameForInvisibleCheck){
																lastAnimationFrameForInvisibleCheck = requestAnimationFrame(function(){
																		lastAnimationFrameForInvisibleCheck = 0;
																		reset();
																});
														}

														return;
												} else {
														// Stop checking
														initialHiddenCheck = false;
												}
										}

										resetExpandShrink();
								};
								element.resizeSensor.resetSensor = reset;

								var onResized = function() {
										rafId = 0;

										if (!dirty) return;

										lastWidth = size.width;
										lastHeight = size.height;

										if (element.resizedAttached) {
												element.resizedAttached.call(size);
										}
								};

								var onScroll = function() {
										size = getElementSize(element);
										dirty = size.width !== lastWidth || size.height !== lastHeight;

										if (dirty && !rafId) {
												rafId = requestAnimationFrame(onResized);
										}

										reset();
								};

								var addEvent = function(el, name, cb) {
										if (el.attachEvent) {
												el.attachEvent('on' + name, cb);
										} else {
												el.addEventListener(name, cb);
										}
								};

								addEvent(expand, 'scroll', onScroll);
								addEvent(shrink, 'scroll', onScroll);

								// Fix for custom Elements and invisible elements
								lastAnimationFrameForInvisibleCheck = requestAnimationFrame(function(){
										lastAnimationFrameForInvisibleCheck = 0;
										reset();
								});
						}

						forEachElement(element, function(elem){
								attachResizeEvent(elem, callback);
						});

						this.detach = function(ev) {
								// clean up the unfinished animation frame to prevent a potential endless requestAnimationFrame of reset
								if (lastAnimationFrameForInvisibleCheck) {
										cancelAnimationFrame(lastAnimationFrameForInvisibleCheck);
										lastAnimationFrameForInvisibleCheck = 0;
								}
								ResizeSensor.detach(element, ev);
						};

						this.reset = function() {
								//To prevent invoking element.resizeSensor.resetSensor if it's undefined
								if (element.resizeSensor.resetSensor) {
										element.resizeSensor.resetSensor();
								}
						};
				};

				ResizeSensor.reset = function(element) {
						forEachElement(element, function(elem){
								//To prevent invoking element.resizeSensor.resetSensor if it's undefined
								if (element.resizeSensor.resetSensor) {
										elem.resizeSensor.resetSensor();
								}
						});
				};

				ResizeSensor.detach = function(element, ev) {
						forEachElement(element, function(elem){
								if (!elem) return;
								if(elem.resizedAttached && typeof ev === "function"){
										elem.resizedAttached.remove(ev);
										if(elem.resizedAttached.length()) return;
								}
								if (elem.resizeSensor) {
										if (elem.contains(elem.resizeSensor)) {
												elem.removeChild(elem.resizeSensor);
										}
										delete elem.resizeSensor;
										delete elem.resizedAttached;
								}
						});
				};

				if (typeof MutationObserver !== "undefined") {
						var observer = new MutationObserver(function (mutations) {
								for (var i in mutations) {
										if (mutations.hasOwnProperty(i)) {
												var items = mutations[i].addedNodes;
												for (var j = 0; j < items.length; j++) {
														if (items[j].resizeSensor) {
																ResizeSensor.reset(items[j]);
														}
												}
										}
								}
						});

						document.addEventListener("DOMContentLoaded", function (event) {
								observer.observe(document.body, {
										childList: true,
										subtree: true,
								});
						});
				}

				return ResizeSensor;

		}));
			var sidebar = new StickySidebar('#sidebar', {
					containerSelector: '#main-content',
					innerWrapperSelector: '.sidebar__inner',
					topSpacing: 120,
					bottomSpacing: 30,
					minWidth: 768
				});
		}
	}



	$( document ).ready(function() {
		$("body,html").one("touchstart touchmove scroll mousemove mousedown DOMMouseScroll mousewheel keyup", function(e){
			var scriptElement = document.createElement('script');
			console.log(scriptElement);
			scriptElement.id = 'usercentrics-cmp';
			scriptElement.src = 'https://app.usercentrics.eu/browser-ui/latest/loader.js';
			scriptElement.setAttribute("data-settings-id", "dsM7OR992");
			document.head.appendChild(scriptElement);
		});
});

	modalTrigger();
	scrollProgression();
  handleBurger();
  handleSubMenus();
  handleFooterMenus();
  handleFancyBox();
  handleSliders();
  handleInfiniteScroll();
  handleSelect();
  handleResourceFilters();
  handleAlert();
  handleResourceTags();
	handleAnimations();

  handleMonthTranslation();
	copyText();
	toggleBoxedAccordion();
	toggleImageAccordion();
	addID();
	sidebarSticky();

  // blocks
  handleAccordionBlock();
  handleLanguagesList();
  footerPopover();
});